import React, { FC, useCallback } from "react";
import { usePayoutInformationContext } from "../context";
import { Card } from "./card";
import { useCardItems, useConsentPoller } from "./hooks";
import { ConsentsDataTableProps } from "./types";

export const ConsentCards: FC<ConsentsDataTableProps> = ({
    className,
    onCardClick,
}) => {
    const { reloadPayoutInformation } = usePayoutInformationContext();

    const handleFirstConsentImported = useCallback(() => {
        reloadPayoutInformation();
    }, [reloadPayoutInformation]);

    useConsentPoller(handleFirstConsentImported);

    const cardItems = useCardItems(onCardClick);

    return (
        <div className={className}>
            {cardItems.map((item) => (
                <Card
                    affiliatedBankId={item.affiliatedBankId}
                    bankName={item.bankName}
                    bankId={item.bankId}
                    bic={item.bic}
                    consents={item.consents}
                    hasPendingConsents={item.hasPendingConsents}
                    key={item.bankId}
                    onClick={item.onClick}
                />
            ))}
        </div>
    );
};
